import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: ${props => (props.size === 'small' ? 'row' : 'column')};
  align-items: center;
  justify-content: center;
  color: #6C727F;
  flex-grow: 1;
`;

export const Icon = styled.div`
  font-size: 72px;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
`;

export const Message = styled.div`
  font-size: 16px;
  font-weight: 400;
  text-align: center;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  margin: ${props => (props.size === 'small' ? '0 0 0 18px' : '18px 0 0')};
`;

export const Text = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
